import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
const DeleteCaseStudyModal = ({
  caseStudyName,
  onConfirm,
  onReject,
  isDeletingCaseStudy
}) => {
  const LoadingButton = useCallback(props => /*#__PURE__*/_jsx(UILoadingButton, {
    use: props.use,
    onClick: props.onClick,
    disabled: props.disabled,
    "data-test-id": props['data-test-id'],
    loading: isDeletingCaseStudy,
    children: props.children
  }), [isDeletingCaseStudy]);
  return /*#__PURE__*/_jsx(UIConfirmModal, {
    ConfirmButton: LoadingButton,
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "caseStudyEditor.deleteModal.confirmButton"
    }),
    "data-test-id": "delete-case-study-modal",
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "caseStudyEditor.deleteModal.rejectButton"
    }),
    confirmUse: "danger",
    description: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "caseStudyEditor.deleteModal.body",
      options: {
        caseStudyName
      }
    }),
    match: I18n.text('caseStudyEditor.deleteModal.delete'),
    matcherLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "caseStudyEditor.deleteModal.matcherLabel"
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "caseStudyEditor.deleteModal.title"
    }),
    size: "auto",
    use: "danger",
    onConfirm: onConfirm,
    onReject: onReject
  });
};
export default DeleteCaseStudyModal;